import { useState } from "react";
import { IDocument } from "../../customTypings/document/Document";
import { IFolder } from "../../customTypings/document/Folder";

interface PathFolder {
  text: string;
  absolutePath: string;
}

export const useDocumentState = (defaultFolder: string) => {
  const [currentPath, setCurrentPath] = useState(defaultFolder);
  const [currentFolder, setCurrentFolder] = useState<IFolder>();
  const [folders, setFolders] = useState<IFolder[]>([]);
  const [documents, setDocuments] = useState<IDocument[]>([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [hasParentFolder, setHasParentFolder] = useState(false);
  const [showAddFolder, setShowAddFolder] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pathFolders, setPathFolders] = useState<PathFolder[]>([]);
  const [selectedView, setSelectedView] = useState("tile");
  const [removeActionActive, setRemoveActionActive] = useState(false);

  return {
    currentPath,
    setCurrentPath,
    currentFolder,
    setCurrentFolder,
    folders,
    setFolders,
    documents,
    setDocuments,
    alertMessage,
    setAlertMessage,
    hasParentFolder,
    setHasParentFolder,
    showAddFolder,
    setShowAddFolder,
    isLoading,
    setIsLoading,
    pathFolders,
    setPathFolders,
    selectedView,
    setSelectedView,
    removeActionActive,
    setRemoveActionActive,
  };
};
